import React from "react"
import "./kitchen.css"
import kitechmenu from "../../data/radhamadhavmenu.json";


function Kitchen() {
    return (
        <section id="pricing-975">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">Hare Krishna</span>
                    <h2 className="cs-title">Radha Madhav Kitchen</h2>
                    <div className="cs-image-picture"> 
                        <picture className="cs-picture">
                            <source media="(max-width: 799px)" srcSet="/images/radhamadhavkitchen.jpg" />
                            <source media="(min-width: 800px)" srcSet="/images/radhamadhavkitchen.jpg" />
                            <img loading="lazy" src="/images/radhamadhavkitchen.jpg" alt="Radha Madhav Kitchen"/>
                        </picture>
                    </div>
                    <br />
                    <p className="cs-text">
                        Kitchen serves full menu featuring vegetarian, sattvic foods, emphasizing pure and light options believed to promote spiritual well-being.
                        <br /><br />
                        Food is cooked with the consciousness of love, knowing that it will be offered and shared with the deities and devotees.
                    </p>
                </div>
                <div className="cs-menu">
                    <ul className="cs-menu-group">
                    {kitechmenu.map((menu, index) => 
                        menu.side === "left" ? (
                        <li className="cs-menu-item" key={index}>
                            <h3 className="cs-h3">
                                <span className="cs-header">{menu.name}</span>
                                <span className="cs-price">{menu.price}</span>
                            </h3>
                            <p className="cs-menu-text">
                                {menu.description}
                            </p>
                        </li>
                        ) : null
                        )}
                    </ul>
                    {/* <!--Right Menu--> */}
                    <ul className="cs-menu-group">
                    {kitechmenu.map((menu, index) => 
                        menu.side === "right" ? (
                        <li className="cs-menu-item" key={index}>
                            <h3 className="cs-h3">
                                <span className="cs-header">{menu.name}</span>
                                <span className="cs-price">{menu.price}</span>
                            </h3>
                            <p className="cs-menu-text">
                                {menu.description}
                            </p>
                        </li>
                        ) : null
                        )}
                    </ul>
                </div>

                <div className="cs-content">
                    <p className="cs-text">
                        We offer a variety of other Sattvic delicious vegetarian dishes, Call us to know more about our menu.
                        <br /><br />
                    </p>
                    <p className="cs-text">
                        Our menu is designed to cater to all tastes and preferences, ensuring that everyone can find something they love.
                    </p>
                </div>
            </div>
        </section>
    )
}
export default Kitchen
                                